(() => {
  const script = document.currentScript;
  const brandId = script?.dataset.r3vyBrand || '';
  if (!brandId) return;

  const trackingAllowed = () => window.R3VY_PARTNER_TRACKING_CONSENT === true
    || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  let captured = false;
  const captureAttribution = () => {
  if (captured || !trackingAllowed()) return;

  const params = new URLSearchParams(window.location.search);
  const cookieValue = (name) => document.cookie.split(';').map((part) => part.trim())
    .find((part) => part.startsWith(`${name}=`))?.slice(name.length + 1) || '';
  let stored = {};
  try {
    stored = JSON.parse(decodeURIComponent(cookieValue('r3vy_attribution'))) || {};
  } catch {
    stored = {};
  }

  const incoming = {
    clickId: params.get('r3vy_click_id') || params.get('r3vy_eid') || params.get('eid') || '',
    campaignId: params.get('r3vy_campaign_id') || '',
    creatorId: params.get('r3vy_creator_id') || params.get('r3vy_ref') || '',
    contentId: params.get('r3vy_content_id') || '',
    utmSource: params.get('utm_source') || '',
    utmMedium: params.get('utm_medium') || '',
    utmCampaign: params.get('utm_campaign') || '',
    utmContent: params.get('utm_content') || '',
    utmTerm: params.get('utm_term') || '',
    googleClickId: params.get('gclid') || ''
  };
  const hasIncoming = Object.values(incoming).some(Boolean);
  const attribution = Object.fromEntries(Object.entries(incoming)
    .map(([key, value]) => [key, hasIncoming ? value : (stored[key] || '')]));
  if (!hasIncoming && !Object.values(attribution).some(Boolean)) return;
  captured = true;

  try {
    document.cookie = `r3vy_attribution=${encodeURIComponent(JSON.stringify(attribution))}; Path=/; Max-Age=${60 * 60 * 24 * 90}; SameSite=Lax; Domain=.getholycow.com; Secure`;
  } catch {
    // Cart attributes remain the durable attribution channel.
  }

  const attributes = {
    r3vy_brand: brandId,
    r3vy_click_id: attribution.clickId,
    r3vy_eid: params.get('eid') || params.get('r3vy_eid') || (attribution.utmMedium === 'email' ? attribution.clickId : ''),
    r3vy_anonymous_visitor_id: decodeURIComponent(cookieValue('holy_cow_anonymous_visitor')),
    r3vy_campaign_id: attribution.campaignId,
    r3vy_creator_id: attribution.creatorId,
    r3vy_content_id: attribution.contentId,
    r3vy_utm_source: attribution.utmSource,
    r3vy_utm_medium: attribution.utmMedium,
    r3vy_utm_campaign: attribution.utmCampaign,
    r3vy_utm_content: attribution.utmContent,
    r3vy_utm_term: attribution.utmTerm,
    r3vy_google_click_id: attribution.googleClickId
  };

  try {
    window.sessionStorage.setItem('r3vy_attribution', JSON.stringify(attributes));
    window.sessionStorage.setItem('r3vy_email_attribution', JSON.stringify(attributes));
  } catch {
    // Cart attributes remain the durable attribution channel.
  }

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes })
  }).catch(() => {
    // Attribution must never interrupt the storefront.
  });
  };
  captureAttribution();
  document.addEventListener('visitorConsentCollected', captureAttribution);
})();
